module.exports = __webpack_public_path__ + "media/customizations/midwaypark/logo-11e5bfe9045f63fec00e75d066994e0e.png";